import { TextField } from "@mui/material";
import moment from "moment";
import { DatePicker, DatePickerProps } from "@mui/x-date-pickers";
import React, { memo } from "react";
import { BE_DATE_FORMAT } from "../../../constants";

export interface PropsDatePickerElement
  extends Omit<
    DatePickerProps<string, Date>,
    "defaultValue" | "onChange" | "minDate" | "maxDate"
  > {
  onChange?: (value: Date | null) => void;
  required?: boolean;
  error?: boolean;
  isSubmitting?: boolean;
  name?: string;
  minDate?: string;
  maxDate?: string;
}

interface Props extends PropsDatePickerElement {}

const DatePickerElement = React.forwardRef<HTMLInputElement, Props>(
  (props: Props, ref) => {
    const {
      name,
      error,
      isSubmitting,
      required,
      value = null,
      minDate,
      maxDate,
      ...rest
    } = props;

    return (
      <DatePicker
        mask="__/__/____"
        fullWidth
        value={value}
        inputRef={ref}
        renderInput={(params) => (
          <TextField
            {...params}
            InputLabelProps={{
              required: required,
            }}
            variant="outlined"
            fullWidth
            error={!!error}
          />
        )}
        minDate={minDate ? moment(minDate, BE_DATE_FORMAT).toDate() : undefined}
        maxDate={maxDate ? moment(maxDate, BE_DATE_FORMAT).toDate() : undefined}
        {...(rest as any)}
      />
    );
  }
);
export default memo(DatePickerElement);
